var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"developing"},[_c('p',[_vm._v("개발 중인 메뉴입니다.")])])}]

export { render, staticRenderFns }